import { useQuery } from '@tanstack/react-query';

import envVars from '../../../constants/envVars';
import useRequest from '../../../hooks/useRequest';
import { CARE_SOURCE } from '../constants';
import { CareRows, CareSuccess } from '../types';
import { CARE_ROWS_KEY, careBillingUrl } from './constants';
import useCareScope from './useCareScope';

const useCareMonthRows = (month: string) => {
    const req = useRequest();
    const orgId = useCareScope();

    const request = () =>
        req<CareSuccess<CareRows>>({
            url: `${envVars.API_RTM_HOSTNAME}${careBillingUrl('month/rows/')}`,
            query: { month, source: CARE_SOURCE }
        }).then((response) => response.data);

    return useQuery({ queryFn: request, queryKey: [CARE_ROWS_KEY, orgId, month] });
};

export default useCareMonthRows;
